module.exports = __webpack_public_path__ + "static/img/application5-3.bb5dfa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application5/application5-3.jpg
// module id = 9otr
// module chunks = 0